<template>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col">
                    <div v-show="isMuteLowNetwork && isMuteLowNetworkMessage !== null"
                         class="alert alert-warning alertLowNetwork">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                                <b-icon-exclamation-triangle-fill/>
                                <div>&nbsp;{{ isMuteLowNetworkMessage }}</div>
                            </div>
                            <div class="btn-close" @click="isMuteLowNetworkMessage = null">
                                <span>&times;</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div :class="{'col-md-8' : !videoSettings.isLargeScreen, 'col-md-4' : videoSettings.isLargeScreen}">
                    <div class="label-username">
                        <span class="small">{{ $locale.patient }}:&nbsp;{{ user ? user.full_name : `退会済の${$locale.patient}` }}</span>
                        <div
                            class="deviceStateWrapper d-flex justify-content-end align-items-center"
                            :class="{
                                'deviceStateWrapperActiveAudio' : remoteAudioState,
                                'deviceStateWrapperActiveVideo' : remoteVideoState,
                                'deviceStateWrapperMuteAudio' : remoteVideoSettings.isMuteAudio,
                                'deviceStateWrapperMuteVideo' : remoteVideoSettings.isMuteVideo
                            }">
                            <div class="audioVolumeAnimationWrapper d-flex justify-content-center align-items-center">
                                <div id="audioVolumeAnimationLeftRemote"/>
                                <div id="audioVolumeAnimationCenterRemote"/>
                                <div id="audioVolumeAnimationRightRemote"/>
                            </div>
                            <div class="deviceStateIcon deviceStateIconAudio">
                                <b-icon :icon="remoteVideoSettings.isMuteAudio ? 'mic-mute-fill' : 'mic-fill'"/>
                            </div>
                            <div class="deviceStateIcon deviceStateIconVideo">
                                <b-icon :icon="remoteVideoSettings.isMuteVideo ? 'camera-video-off-fill' : 'camera-video-fill'"/>
                            </div>
                        </div>
                    </div>

                    <fullscreen ref="fullscreen" :fullscreen.sync="fullscreen">
                        <div class="videoContainer" :class="{ 'videoContainer--fluid' : !fullscreen && remoteVideo !== null }">
                            <div class="videoContainer__inner">
                                <div class="remoteVideoWrapper">
                                    <div
                                        id="remote-video"
                                        :class="{
                                            'invisible' : remoteVideoSettings.isMuteVideo,
                                            'remoteVideoLarge' : !videoSettings.isLargeScreen
                                        }">
                                    </div>
                                    <div
                                        v-if="remoteVideoSettings.isMuteVideo"
                                        class="remoteVideoMuted d-flex justify-content-center align-items-center">
                                        <b-icon icon="camera-video-off-fill"/>
                                    </div>
                                </div>

                                <div v-if="remoteVideo !== null">
                                    <div class="video-capture"
                                         :class="{
                                             'video-capture--consul' : $locale.type === 'consul',
                                             'video-capture--progress' : inProgress.capture
                                         }"
                                         @click="capture">

                                        <div class="c-icon c-icon--camera"></div>
                                        <div v-if="inProgress.capture">撮影中…</div>
                                        <div v-else>撮影する</div>
                                    </div>

                                    <div class="c-icon c-icon--fullscreen" @click="fullscreenToggle"></div>
                                </div>
                                <div
                                    v-else-if="remoteVideo === null && !remoteVideoSettings.isMuteVideo"
                                    class="videoContainer__dummy">
                                    <img
                                        class="videoContainerDummyImage"
                                        src="/images/common/profile_default.svg">
                                </div>
                            </div>
                        </div>
                    </fullscreen>

                    <canvas id="canvas" class="d-none"></canvas>
                    <img id="captured-photo" class="d-none" src="">
                </div>

                <div :class="{'col-md-8' : videoSettings.isLargeScreen, 'col-md-4' : !videoSettings.isLargeScreen}">
                    <div class="label-you">
                        <span class="small">あなた</span>
                        <div
                            class="deviceStateWrapper d-flex justify-content-end align-items-center"
                            :class="{
                                'deviceStateWrapperActiveAudio' : selectedAudioId !== null && localAudioState,
                                'deviceStateWrapperActiveVideo' : selectedVideoId !== null && localVideoState,
                                'deviceStateWrapperMuteAudio' : selectedAudioId !== null && localAudioState && videoSettings.isMuteAudio,
                                'deviceStateWrapperMuteVideo' : selectedVideoId !== null && localVideoState && videoSettings.isMuteVideo,
                            }">
                            <div class="audioVolumeAnimationWrapper d-flex justify-content-center align-items-center">
                                <div id="audioVolumeAnimationLeft"/>
                                <div id="audioVolumeAnimationCenter"/>
                                <div id="audioVolumeAnimationRight"/>
                            </div>
                            <div class="deviceStateIcon deviceStateIconAudio">
                                <b-icon :icon="selectedAudioId !== null && localAudioState && videoSettings.isMuteAudio ? 'mic-mute-fill' : 'mic-fill'"/>
                            </div>
                            <div class="deviceStateIcon deviceStateIconVideo">
                                <b-icon :icon="selectedVideoId !== null && localVideoState && videoSettings.isMuteVideo ? 'camera-video-off-fill' : 'camera-video-fill'"/>
                            </div>
                        </div>
                    </div>

                    <div class="videoContainer">
                        <div class="videoContainer__inner">
                            <div class="localVideoWrapper">
                                <div
                                    id="local-video"
                                    :class="{ 'invisible' : videoSettings.isMuteVideo }">
                                </div>
                                <div
                                    v-if="videoSettings.isMuteVideo"
                                    class="localVideoMuted d-flex justify-content-center align-items-center">
                                    <b-icon icon="camera-video-off-fill"/>
                                </div>
                            </div>
                        </div>
                        <img
                            class="localVideoLogo"
                            :class="{ 'large': videoSettings.isLargeScreen === true }"
                            :src="srcLocalVideoLogo"/>
                    </div>

                    <div
                        v-if="selectedVideoId !== null"
                        class="settingIconsWrapper d-flex justify-content-center align-items-center">
                        <div
                            :class="{ 'iconLargeScreenOn' : videoSettings.isLargeScreen, 'iconLargeScreenOff' : !videoSettings.isLargeScreen }"
                            class="settingIcon d-flex align-items-center justify-content-center"
                            @click="toggleLargeScreen">
                            <img :src="`/images/common/icon_screen_${videoSettings.isLargeScreen ? 'large' : 'small' }.svg`">
                        </div>
                        <div
                            :class="{ 'iconBlurOn' : videoSettings.isBlur, 'iconBlurOff' : !videoSettings.isBlur }"
                            class="settingIcon d-flex align-items-center justify-content-center"
                            @click="toggleBlur">
                            <img :src="`/images/common/icon_${videoSettings.isBlur ? 'blur_on' : 'blur_off' }.svg`">
                        </div>
                        <div
                            :class="{ 'iconMuteAudioOn' : videoSettings.isMuteAudio, 'iconMuteAudioOff' : !videoSettings.isMuteAudio }"
                            class="settingIcon d-flex align-items-center justify-content-center"
                            @click="toggleMuteAudio">
                            <b-icon :icon="videoSettings.isMuteAudio ? 'mic-mute-fill' : 'mic-fill'"/>
                        </div>
                        <div
                            v-if="isMuteLowNetwork"
                            :class="{ 'iconMuteVideoOn' : videoSettings.isMuteVideo, 'iconMuteVideoOff' : !videoSettings.isMuteVideo }"
                            class="settingIcon d-flex align-items-center justify-content-center"
                            @click="toggleMuteVideo">
                            <b-icon :icon="videoSettings.isMuteVideo ? 'camera-video-off-fill' : 'camera-video-fill'"/>
                        </div>
                        <div
                            :class="{ 'iconShareScreenOn' : videoSettings.isShareScreen, 'iconShareScreenOff' : !videoSettings.isShareScreen }"
                            class="settingIcon d-flex align-items-center justify-content-center"
                            @click="toggleShareScreen">
                            <b-icon icon="play-btn"/>
                        </div>
                    </div>

                    <div class="devicesWrapper">
                        <template v-if="selectedVideoId !== null">
                            <div class="deviceContainer mb-1">
                                <b-icon-camera-video-fill/>
                                <select
                                    v-model="selectedVideoId"
                                    class="custom-select small">
                                    <option
                                        v-for="video in videos"
                                        :value="video.deviceId"
                                        :key="video.deviceId">
                                        {{ video.label }}
                                    </option>
                                </select>
                            </div>
                        </template>

                        <template v-if="selectedAudioId !== null">
                            <div class="deviceContainer">
                                <b-icon-mic/>
                                <select
                                    v-model="selectedAudioId"
                                    class="custom-select small">
                                    <option
                                        v-for="audio in audios"
                                        :value="audio.deviceId"
                                        :key="audio.deviceId">
                                        {{ audio.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="toggleDenoiserWrapper d-flex justify-content-end align-items-center">
                                <div>マイクのノイズを除去する</div>
                                <toggle v-model="videoSettings.isDenoiser"/>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AgoraRTC from 'agora-rtc-sdk-ng'
import VirtualBackgroundExtension from 'agora-extension-virtual-background'
import { AIDenoiserExtension } from 'agora-extension-ai-denoiser'

import Fullscreen from 'vue-fullscreen/src/component.vue'
import constants from '../../constants'
import { mapMutations } from 'vuex'

export default {
    props: {
        roomKey: {
            type: String,
            default: '',
        },
        apiKey: {
            type: String,
            default: '',
        },
        token: {
            type: String,
            default: '',
        },
        screenToken: {
            type: String,
            default: '',
        },
        // @see https://docs.agora.io/en/Video/API%20Reference/web_ng/interfaces/clientconfig.html#mode
        transcode: {
            type: String,
            default: 'rtc',
        },
        debug: {
            type: String,
            default: '0',
        },
        user: {
            type: Object,
            default: null,
        },
        consultation: {
            type: Object,
            default: null,
        },
    },

    components: {
        Fullscreen,
    },

    data: function () {
        return {
            client: null,
            screenClient: null,
            processor: {
                vb: null,
                denoiser: null,
            },
            localScreen: null,
            localVideo: null,
            localAudio: null,
            remoteVideo: null,
            remoteAudio: null,
            volumeAnimation: null,
            timerUpdateLocalDevices: null,
            timerUpdateLocalState: null,
            timerUpdateRemoteState: null,
            timerUpdateRtcStats: null,
            videos: [],
            audios: [],
            selectedVideoId: null,
            selectedAudioId: null,
            localVideoState: false,
            localAudioState: false,
            remoteVideoState: false,
            remoteAudioState: false,
            qualityHistory: {
                remote: { down: [], up: [] },
                local: { down: [], up: [] },
            },
            currentEncode: null,
            highEncode: '480p_1',
            lowEncode: {
                width: 160,
                height: 120,
                frameRate: 4,
                bitrateMin: 40,
                bitrateMax: 120,
            },
            isEncodeRollback: false,
            fullscreen: false,
            videoSettings: {
                isLargeScreen: false,
                isMuteAudio: false,
                isMuteVideo: false,
                isBlur: false,
                isShareScreen: false,
                isDenoiser: false,
            },
            remoteVideoSettings: {
                isMuteAudio: false,
                isMuteVideo: false,
            },
            inProgress: {
                capture: false,
                switchLocalVideo: false,
                switchLocalAudio: false,
            },
            agoraInitState: {
                errorHandled: false,
            },
            // @reference https://api-ref.agora.io/en/video-sdk/web/4.x/interfaces/iagorartcclient.html#event_exception
            exceptions: [
                'RECV_VIDEO_DECODE_FAILED',
                'RECV_AUDIO_DECODE_FAILED',
            ],
            isMuteLowNetwork: false,
            isMuteLowNetworkMessage: `${this.$locale.patient}側のネットワークが低速のためビデオをミュートしました。音声のみによる${this.$locale.consultation_host}を推奨します。`
        }
    },

    computed: {
        srcLocalVideoLogo: function () {
            if (this.$locale.type === 'consul') {
                return '/images/common/logo_yokumiru.svg'
            }
            return '/images/common/logo.svg'
        },

        /**
         * agoraセッションにおけるユニークID
         * 先頭が2の場合は医師と見なす
         *
         * @return {number}
         */
        uid: function () {
            const id = '2' + this.consultation.id.toString()
            return Number(id)
        },

        /**
         * agoraセッションにおけるユニークID
         * 先頭が2の場合は医師と見なす
         *
         * @return {number}
         */
        remoteUid: function () {
            const id = '1' + this.consultation.id.toString()
            return Number(id)
        },

        /**
         * agoraセッションにおけるユニークID
         * 先頭が5の場合は医師の画面共有と見なす
         *
         * @return {number}
         */
        uidScreen: function () {
            const id = '5' + this.consultation.id.toString()
            return Number(id)
        },

        /**
         * デバッグモード判定
         *
         * @return {boolean}
         */
        isDebug: function () {
            return this.debug === '1'
        },

        /**
         * AgoraRTCのログレベル
         *
         * @return {number}
         */
        agoraLogLevel: function () {
            return this.isDebug ? 0 : 4
        },
    },

    watch: {
        selectedVideoId: function () {
            this.switchVideo()
        },

        selectedAudioId: function () {
            this.switchAudio()
        },

        'videoSettings.isDenoiser': function () {
            this.toggleDenoiser(true)
        },
    },

    created: function () {
        this.currentEncode = this.lowEncode
        this.initVideoSettings()

        bus.$on('doctor-agora-init', this.initAgora)
        bus.$on('doctor-agora-should-clear', this.clearAllMediaAndLeave)
        // bus.$on('doctor-agora-should-init', this.initAgoraIfRequired)
    },

    beforeDestroy: function () {
        bus.$off('doctor-agora-init')
        bus.$off('doctor-agora-should-clear')
        // bus.$off('doctor-agora-should-init')
    },

    methods: {
        ...mapMutations({
            setIsBlur: 'doctorVideoSettings/setIsBlur',
            setIsMuteAudio: 'doctorVideoSettings/setIsMuteAudio',
            setIsDenoiser: 'doctorVideoSettings/setIsDenoiser',
        }),

        /**
         * CloudWatch Logs キュー追加
         *
         * @param {string} message
         */
        queueCwLogs: function (message) {
            bus.$emit('queue-cloud-watch-logs-doctor', message)
        },

        /**
         * ビデオ通話設定をvuxからロード
         */
        initVideoSettings: function () {
            this.videoSettings.isBlur = !!this.$store.state.doctorVideoSettings.isBlur
            this.videoSettings.isMuteAudio = !!this.$store.state.doctorVideoSettings.isMuteAudio
            this.videoSettings.isMuteVideo = false // 会員が低速回線の場合のみ切り替えるため、vuexでは状態保持しない
            this.videoSettings.isDenoiser = !!this.$store.state.doctorVideoSettings.isDenoiser
        },

        /**
         * 初期化処理
         */
        initAgora: async function () {
            if (this.client !== null) return

            if (!AgoraRTC.checkSystemRequirements()) {
                this.queueCwLogs('[doctor] AgoraRTC.checkSystemRequirements(): System requirements not met.')
            }

            // ログレベル 4:NONE であっても、背景ぼかしなどの拡張機能系はログ出力される仕様と思われる
            AgoraRTC.setLogLevel(4)
            //AgoraRTC.setLogLevel(this.agoraLogLevel)

            /**
             * @type {IAgoraRTCClient}
             * @see https://docs.agora.io/en/Video/API%20Reference/web_ng/interfaces/iagorartc.html#createclient
             * @see https://docs.agora.io/en/Video/API%20Reference/web_ng/interfaces/clientconfig.html
             */
            this.client = AgoraRTC.createClient({ mode: this.transcode, codec: 'vp8' })

            // 拡張機能の登録
            // @see https://github.com/sewii/Yokumiru/issues/400
            // @see https://github.com/sewii/Yokumiru/issues/543
            const extension = {
                vb: new VirtualBackgroundExtension(),
                denoiser: new AIDenoiserExtension({ assetsPath:'/agora/denoiser/wasms' }),
            }
            AgoraRTC.registerExtensions([
                extension.vb,
                extension.denoiser,
            ])

            // 拡張機能の初期化: 背景ぼかし
            this.processor.vb = extension.vb.createProcessor()
            await this.processor.vb.init('/storage/agora/virtual-background/wasms')

            // 拡張機能の初期化: ノイズリダクション
            this.processor.denoiser = extension.denoiser.createProcessor()

            // イベントリスナ追加
            this.subscribeStreamEvents()

            /**
             * @see https://docs.agora.io/en/Video/API%20Reference/web_ng/interfaces/iagorartcclient.html#join
             */
            await this.client.join(this.apiKey, this.roomKey, this.token, this.uid)
                .then((uid) => {
                    this.queueCwLogs(`[doctor] client join success. uid:${uid}`)
                    this.timerUpdateLocalDevices = setInterval(() => this.updateLocalDevices(), 2000)
                    this.timerUpdateLocalState = setInterval(() => this.updateLocalState(), 2000)
                    this.timerUpdateRemoteState = setInterval(() => this.updateRemoteState(), 5000)
                    this.timerUpdateRtcStats = setInterval(() => this.updateRtcStats(), 5000)
                })
                .catch((e) => {
                    this.agoraInitState.errorHandled = true
                    this.queueCwLogs(`[doctor] client join failed. ${e}`)
                })

            // client.join 後すぐに取得だと取れないケースがあるためディレイをかける
            setTimeout(() => this.logLocalTracks(), 5000)
            if (this.client) {
                this.queueCwLogs(`[doctor] agora channelName:${this.client.channelName} uid:${this.client.uid} connectionState:${this.client.connectionState}`)
            }
        },

        // /**
        //  * 初期化処理（必要時のみ）
        //  *
        //  * 必要時の例: 相談終了→ブラウザリロード無しで相談再開
        //  * 不要時の例: 相談終了→ブラウザリロード後に相談再開
        //  *
        //  * ブラウザリロード後なら 'doctor-agora-init' 経由で initAgora() が実行される。そちらに任せればよいため不要。
        //  */
        // initAgoraIfRequired: function () {
        //     setTimeout(() => {
        //         // 少し待ってから null の場合のみ初期化を行う
        //         if (this.client === null) {
        //             this.initAgora()
        //         }
        //         else if (this.localVideo === null) {
        //             this.client.join(this.apiKey, this.roomKey, this.token, this.uid)
        //                 .then((uid) => {
        //                     this.queueCwLogs(`[doctor] client join success. uid:${uid}`)
        //                     this.timerUpdateLocalDevices = setInterval(() => this.updateLocalDevices(), 2000)
        //                     this.timerUpdateLocalState = setInterval(() => this.updateLocalState(), 2000)
        //                     this.timerUpdateRemoteState = setInterval(() => this.updateRemoteState(), 5000)
        //                     this.timerUpdateRtcStats = setInterval(() => this.updateRtcStats(), 5000)
        //                 })
        //                 .catch((e) => {
        //                     this.agoraInitState.errorHandled = true
        //                     this.queueCwLogs(`[doctor] client join failed. ${e}`)
        //                 })
        //
        //             // client.join 後すぐに取得だと取れないケースがあるためディレイをかける
        //             setTimeout(() => this.logLocalTracks(), 5000)
        //             if (this.client) {
        //                 this.queueCwLogs(`[doctor] agora channelName:${this.client.channelName} uid:${this.client.uid} connectionState:${this.client.connectionState}`)
        //             }
        //         }
        //     }, 300)
        // },

        /**
         * LocalVideoを初期化
         */
        initLocalVideo: async function () {
            if (this.selectedVideoId) {
                try {
                    this.localVideo = await AgoraRTC.createCameraVideoTrack({
                        cameraId: this.selectedVideoId,
                        encoderConfig: this.currentEncode,
                    })
                    await this.localVideo.setMuted(this.videoSettings.isMuteVideo)

                    if (this.videoSettings.isBlur) {
                        try {
                            await this.enableVideoBlur()
                        }
                        catch (e) {
                            const format = `[doctor] enable virtual background processor failed. ${e}`
                            this.queueCwLogs(format)
                            console.log(format)
                        }
                    }
                    this.localVideo.play('local-video')
                    const format = '[doctor] create local video success.'
                    this.queueCwLogs(format)
                    console.log(format)
                }
                catch (e) {
                    this.agoraInitState.errorHandled = true
                    window.alert('ブラウザのカメラ使用を許可した状態で再入室してください。')
                    const format = `[doctor] create local video failed. ${e}`
                    this.queueCwLogs(format)
                    console.log(format)
                    return
                }
            }

            try {
                await this.client.publish(this.localVideo)
                const format = '[doctor] publish local video success.'
                this.queueCwLogs(format)
                console.log(format)
            }
            catch (e) {
                this.agoraInitState.errorHandled = true
                const format = `[doctor] publish local video failed. ${e}`
                this.queueCwLogs(format)
                console.log(format)
            }
        },

        /**
         * マイク音量のプログレスバーアニメーション
         */
        setVolumeWave: function () {
            this.volumeAnimation = requestAnimationFrame(this.setVolumeWave)

            // アニメーションを行うマイク音量のしきい値
            const threshold = 15

            if (this.localAudio !== null) {
                const $left = $('#audioVolumeAnimationLeft')
                const $center = $('#audioVolumeAnimationCenter')
                const $right = $('#audioVolumeAnimationRight')

                // height
                let volumeLevel = this.localAudio.getVolumeLevel() * 100
                let unitVolume = '%'
                if (volumeLevel < threshold) {
                    volumeLevel = 5
                    unitVolume = 'px'
                }

                let centerVolumeLevel = volumeLevel
                if (centerVolumeLevel >= threshold) {
                    centerVolumeLevel += 18
                }
                if (centerVolumeLevel > 100) {
                    centerVolumeLevel = 100
                }

                // border-radius
                let radius = 50
                let unitRadius = '%'
                if (volumeLevel >= threshold) {
                    radius = 10
                    unitRadius = 'px'
                }

                $left.css('height', volumeLevel + unitVolume)
                $left.css('border-radius', radius + unitRadius)

                $center.css('height', centerVolumeLevel + unitVolume)
                $center.css('border-radius', radius + unitRadius)

                $right.css('height', volumeLevel + unitVolume)
                $right.css('border-radius', radius + unitRadius)
            }

            if (this.remoteAudio !== null) {
                const $left = $('#audioVolumeAnimationLeftRemote')
                const $center = $('#audioVolumeAnimationCenterRemote')
                const $right = $('#audioVolumeAnimationRightRemote')

                // height
                let volumeLevel = this.remoteAudio.getVolumeLevel() * 100
                let unitVolume = '%'
                if (volumeLevel < threshold) {
                    volumeLevel = 5
                    unitVolume = 'px'
                }

                let centerVolumeLevel = volumeLevel
                if (centerVolumeLevel >= threshold) {
                    centerVolumeLevel += 18
                }
                if (centerVolumeLevel > 100) {
                    centerVolumeLevel = 100
                }

                // border-radius
                let radius = 50
                let unitRadius = '%'
                if (volumeLevel >= threshold) {
                    radius = 10
                    unitRadius = 'px'
                }

                $left.css('height', volumeLevel + unitVolume)
                $left.css('border-radius', radius + unitRadius)

                $center.css('height', centerVolumeLevel + unitVolume)
                $center.css('border-radius', radius + unitRadius)

                $right.css('height', volumeLevel + unitVolume)
                $right.css('border-radius', radius + unitRadius)
            }
        },

        /**
         * LocalAudioを初期化
         */
        initLocalAudio: async function () {
            if (this.selectedAudioId) {
                try {
                    this.localAudio = await AgoraRTC.createMicrophoneAudioTrack({ microphoneId: this.selectedAudioId })
                    await this.localAudio.setMuted(this.videoSettings.isMuteAudio)

                    if (this.videoSettings.isDenoiser) {
                        try {
                            await this.enableDenoiser()
                        }
                        catch (e) {
                            const format = `[doctor] enable denoiser processor failed. ${e}`
                            this.queueCwLogs(format)
                            console.log(format)
                        }
                    }
                    this.volumeAnimation = requestAnimationFrame(this.setVolumeWave)
                    const format = '[doctor] create local audio success.'
                    this.queueCwLogs(format)
                    console.log(format)
                }
                catch (e) {
                    this.agoraInitState.errorHandled = true
                    window.alert('ブラウザのマイク使用を許可した状態で再入室してください。')
                    const format = `[doctor] create local audio failed. ${e}`
                    this.queueCwLogs(format)
                    console.log(format)
                    return
                }
            }

            try {
                await this.client.publish(this.localAudio)
                const format = '[doctor] publish local audio success.'
                this.queueCwLogs(format)
                console.log(format)
            }
            catch (e) {
                this.agoraInitState.errorHandled = true
                const format = `[doctor] publish local audio failed. ${e}`
                this.queueCwLogs(format)
                console.log(format)
            }
        },

        /**
         * 医師のメディアをクリア
         */
        clearLocalMedia: function () {
            if (this.localVideo !== null) {
                this.localVideo.close()
                this.client.unpublish(this.localVideo)
                this.localVideo = null
            }

            if (this.localAudio !== null) {
                this.localAudio.close()
                this.client.unpublish(this.localAudio)
                this.localAudio = null
            }
        },

        /**
         * 会員の接続メディアをクリア
         *
         * @param {string} mediaType
         */
        clearRemoteMedia: function (mediaType = 'all') {
            if (mediaType === 'video' || mediaType === 'all') {
                if (this.remoteVideo) {
                    this.remoteVideo.stop()
                }
                this.remoteVideo = null
            }

            if (mediaType === 'audio' || mediaType === 'all') {
                if (this.remoteAudio) {
                    this.remoteAudio.stop()
                }
                this.remoteAudio = null
            }

            this.queueCwLogs(`[doctor] remote media cleared. mediaType:${mediaType}`)
        },

        /**
         * すべてのメディアをクリアしてチャンネルから退室
         */
        clearAllMediaAndLeave: function () {
            clearInterval(this.timerUpdateLocalDevices)
            clearInterval(this.timerUpdateLocalState)
            clearInterval(this.timerUpdateRemoteState)
            clearInterval(this.timerUpdateRtcStats)

            this.clearRemoteMedia()
            this.clearLocalMedia()
            this.client.leave()

            this.videos = []
            this.audios = []
            this.selectedVideoId = null
            this.selectedAudioId = null
            this.localVideoState = false
            this.localAudioState = false
            this.remoteVideoState = false
            this.remoteAudioState = false
        },

        /**
         * uid頭文字を取得
         *
         * @param {number} uid
         * @return {string}
         */
        initialStrNum: function (uid) {
            return (uid + '').slice(0, 1)
        },

        /**
         * Agoraのイベントリスナ追加
         */
        subscribeStreamEvents: function () {
            /**
             * @reference https://docs.agora.io/en/voice/API%20Reference/web_ng/interfaces/iagorartcclient.html#event_user_published
             */
            this.client.on('user-published', async (remoteUser, mediaType) => {
                // 会員ではない場合
                if (this.initialStrNum(remoteUser.uid) !== '1') {
                    return
                }

                await this.client.subscribe(remoteUser, mediaType)

                if (mediaType === 'video') {
                    this.remoteVideo = remoteUser.videoTrack
                    this.remoteVideo.play('remote-video')
                    const format = '[doctor] subscribe remote video success.'
                    this.queueCwLogs(format)
                    console.log(format)
                }
                if (mediaType === 'audio') {
                    this.remoteAudio = remoteUser.audioTrack
                    this.remoteAudio.play()
                    const format = '[doctor] subscribe remote audio success.'
                    this.queueCwLogs(format)
                    console.log(format)
                }
                this.updateRemoteState()
            })

            /**
             * @reference https://docs.agora.io/en/voice/API%20Reference/web_ng/interfaces/iagorartcclient.html#event_user_unpublished
             */
            this.client.on('user-unpublished', async (remoteUser, mediaType) => {
                // 会員ではない場合
                if (this.initialStrNum(remoteUser.uid) !== '1') {
                    return
                }

                await this.client.unsubscribe(remoteUser, mediaType)

                if (mediaType === 'video') {
                    this.clearRemoteMedia(mediaType)
                    this.updateRemoteState()
                    const format = '[doctor] unsubscribe remote video success.'
                    this.queueCwLogs(format)
                    console.log(format)
                }

                if (mediaType === 'audio') {
                    this.clearRemoteMedia(mediaType)
                    this.updateRemoteState()
                    const format = '[doctor] unsubscribe remote audio success.'
                    this.queueCwLogs(format)
                    console.log(format)
                }
            })

            /**
             * @reference https://docs.agora.io/en/voice/API%20Reference/web_ng/interfaces/iagorartcclient.html#event_user_info_updated
             */
            this.client.on('user-info-updated', async (uid, msg) => {
                // 会員ではない場合
                if (this.initialStrNum(uid) !== '1') {
                    return
                }

                let isUnMute = false

                if (msg === 'mute-video') {
                    this.remoteVideoSettings.isMuteVideo = true
                }
                else if (msg === 'mute-audio') {
                    this.remoteVideoSettings.isMuteAudio = true
                }
                else if (msg === 'unmute-video') {
                    this.remoteVideoSettings.isMuteVideo = false
                    isUnMute = true
                }
                else if (msg === 'unmute-audio') {
                    this.remoteVideoSettings.isMuteAudio = false
                    isUnMute = true
                }

                if (isUnMute) {
                    // ミュート解除時のみステータスアイコン反映を早く行う（updateRemoteState経由だと反映が遅くなるため）
                    setTimeout(() => {
                        this.remoteVideoState = this.remoteVideo && this.remoteVideo.isPlaying
                        this.remoteAudioState = this.remoteAudio && this.remoteAudio.isPlaying
                    }, 1000)
                }

                const format = `[doctor] remote user info updated. | ${msg}`
                this.queueCwLogs(format)
                console.log(format)
            })

            /**
             * @reference https://docs.agora.io/en/voice/API%20Reference/web_ng/interfaces/iagorartcclient.html#event_user_joined
             */
            this.client.on('user-joined', async (remoteUser) => {
                // 会員ではない場合
                if (this.initialStrNum(remoteUser.uid) !== '1') {
                    return
                }

                const format = '[doctor] remote user joined.'
                this.queueCwLogs(format)
                console.log(format)
            })

            /**
             * @reference https://docs.agora.io/en/voice/API%20Reference/web_ng/interfaces/iagorartcclient.html#event_user_left
             */
            this.client.on('user-left', async (remoteUser, reason) => {
                // 会員ではない場合
                if (this.initialStrNum(remoteUser.uid) !== '1') {
                    return
                }

                this.remoteVideoSettings.isMuteAudio = false
                this.remoteVideoSettings.isMuteVideo = false
                const format = `[doctor] remote user left. | reason: ${reason}`
                this.queueCwLogs(format)
                console.log(format)
            })

            /**
             * @see https://docs.agora.io/en/video-calling/enhance-call-quality/in-call-quality-monitoring?platform=web
             * @reference https://api-ref.agora.io/en/video-sdk/web/4.x/interfaces/iagorartcclient.html#event_exception
             */
            this.client.on('exception', (e) => {
                const format = `[doctor] exception: ${e.code} ${e.msg} ${e.uid}`
                this.queueCwLogs(format)
                console.log(format)

                // リモート（会員）のビデオ・音声デコードに失敗したException発生時はビデオを自動的にミュートする
                if (this.localVideo && this.exceptions.includes(e.msg) && !this.isMuteLowNetwork) {
                    this.videoSettings.isMuteVideo = true
                    this.localVideo.setMuted(true)
                    // this.setIsMuteVideo(this.videoSettings.isMuteVideo)
                    const format = '[doctor] Exception localVideo muted.'
                    this.queueCwLogs(format)
                    console.log(format)

                    this.isMuteLowNetwork = true
                }
            })

            /**
             * @see https://docs.agora.io/en/video-calling/enhance-call-quality/in-call-quality-monitoring?platform=web
             * @reference https://api-ref.agora.io/en/video-sdk/web/4.x/interfaces/iagorartcclient.html#event_network_quality
             */
            this.client.on('network-quality', (stats) => {
                if (!this.localVideo) return

                const down = stats.downlinkNetworkQuality
                const up = stats.uplinkNetworkQuality
                this.updateLocalQualityHistory(down, up)

                const format = `[doctor] localNetworkQuality (down / up): ${down} ${up}`
                this.queueCwLogs(format)
                // console.log(format)

                this.adjustEncode()
            })
        },

        /**
         * 自身の通信環境履歴を更新
         * @param down
         * @param up
         */
        updateLocalQualityHistory: function (down, up) {
            this.qualityHistory.local.down.push(down)
            this.qualityHistory.local.up.push(up)

            if (this.qualityHistory.local.down.length > 5) {
                this.qualityHistory.local.down.shift()
            }
            if (this.qualityHistory.local.up.length > 5) {
                this.qualityHistory.local.up.shift()
            }
        },

        /**
         * 相手の通信環境履歴を更新
         * @param down
         * @param up
         */
        updateRemoteQualityHistory: function (down, up) {
            this.qualityHistory.remote.down.push(down)
            this.qualityHistory.remote.up.push(up)

            if (this.qualityHistory.remote.down.length > 5) {
                this.qualityHistory.remote.down.shift()
            }
            if (this.qualityHistory.remote.up.length > 5) {
                this.qualityHistory.remote.up.shift()
            }
        },

        /**
         * NetworkQualityの履歴から最適なエンコードを返す
         * @see https://api-ref.agora.io/en/video-sdk/web/4.x/interfaces/networkquality.html
         * @return {string|object}
         */
        guessOptimalEncode: function () {
            const localDown = this.qualityHistory.local.down
            const localUp = this.qualityHistory.local.up
            const remoteDown = this.qualityHistory.remote.down
            const remoteUp = this.qualityHistory.remote.up
            // console.log(`[local] down:${down} up: ${up}`)
            // console.log(`[remote] down:${down} up: ${up}`)

            // NetworkQualityの履歴が down / up 共に5件揃っていない場合はスキップ
            if (localDown.length < 5
                || localUp.length < 5
                || remoteDown.length < 5
                || remoteUp.length < 5) {
                return this.currentEncode
            }

            // NetworkQualityの履歴に0以下または7以上の品質が存在する場合はスキップ
            if (localDown.some((v) => v < 1 || v > 6)
                || localUp.some((v) => v < 1 || v > 6)
                || remoteDown.some((v) => v < 1 || v > 6)
                || remoteUp.some((v) => v < 1 || v > 6)) {
                return this.currentEncode
            }

            // NetworkQualityの履歴全てが1〜3の品質なら480pに上げる
            if (localDown.every((v) => v > 0 && v < 4)
                && localUp.every((v) => v > 0 && v < 4)
                && remoteDown.every((v) => v > 0 && v < 4)
                && remoteUp.every((v) => v > 0 && v < 4)) {
                return this.highEncode
            }
            return this.lowEncode
        },

        /**
         * 自身（医師）のデバイス状態を更新
         */
        updateLocalState: function () {
            if (!this.localVideo) return

            if (this.localVideo) {
                const stats = this.localVideo.getStats()
                const format = `[doctor] localVideo stats | ${JSON.stringify(stats)}`
                this.queueCwLogs(format)
                // console.log(format)
            }
            if (this.localAudio) {
                const stats = this.localAudio.getStats()
                const format = `[doctor] localAudio stats | ${JSON.stringify(stats)}`
                this.queueCwLogs(format)
                // console.log(format)
            }

            const netStats = this.client.getRemoteNetworkQuality()
            if (netStats[this.remoteUid] !== void(0)) {
                const down = netStats[this.remoteUid].downlinkNetworkQuality
                const up = netStats[this.remoteUid].uplinkNetworkQuality
                this.updateRemoteQualityHistory(down, up)

                const format = `[doctor] remoteNetworkQuality (down / up): ${down} ${up}`
                this.queueCwLogs(format)
                // console.log(format)

                this.adjustEncode()

                const remoteDown = this.qualityHistory.remote.down
                const remoteUp = this.qualityHistory.remote.up
                // console.log("remoteDown:", remoteDown)
                // console.log("remoteUp:", remoteUp)
                const lowDownCount = remoteDown.filter((v) => v >= 4 && v <= 6).length
                const lowUpCount = remoteUp.filter((v) => v >= 4 && v <= 6).length

                // リモート（会員）のNetworkQualityの履歴が5件揃っており、全て低品質（4〜6）の場合はビデオを自動的にミュートする
                if (
                    !this.isMuteLowNetwork
                    && (remoteDown.length >= 5 && remoteUp.length >= 5)
                    && (lowDownCount >= 5 || lowUpCount >= 5)
                ) {
                    this.videoSettings.isMuteVideo = true
                    this.localVideo.setMuted(true)
                    // this.setIsMuteVideo(this.videoSettings.isMuteVideo)
                    const format = '[doctor] adjustEncode localVideo muted.'
                    this.queueCwLogs(format)
                    console.log(format)

                    this.isMuteLowNetwork = true
                }
            }
        },

        /**
         * localVideoの画質調整
         */
        adjustEncode: function () {
            // lowEncode→highEncodeに変わった後、再度lowに落ちた場合はそれ以上変更しない
            if (this.isEncodeRollback) return

            const encode = this.guessOptimalEncode()
            if (encode !== this.currentEncode) {
                this.currentEncode = encode
                if (this.currentEncode !== this.highEncode) {
                    this.isEncodeRollback = true
                }

                this.localVideo.setEncoderConfiguration(this.currentEncode).then(() => {
                    const enc = this.currentEncode === this.highEncode ? 'high' : 'low'
                    const format = `[doctor] localVideo encode changed to ${enc}.`
                    this.queueCwLogs(format)
                    console.log(format)
                })
            }
        },

        /**
         * 相手（会員）のデバイス接続ステータスを更新
         */
        updateRemoteState: function () {
            this.remoteVideoState = this.remoteVideo && this.remoteVideo.isPlaying
            this.remoteAudioState = this.remoteAudio && this.remoteAudio.isPlaying

            if (this.remoteVideo) {
                const stats = this.remoteVideo.getStats()
                const format = `[doctor] remoteVideo stats | ${JSON.stringify(stats)}`
                this.queueCwLogs(format)
                // console.log(format)
            }
            if (this.remoteAudio) {
                const stats = this.remoteAudio.getStats()
                const format = `[doctor] remoteAudio stats | ${JSON.stringify(stats)}`
                this.queueCwLogs(format)
                // console.log(format)
            }
        },

        /**
         * RTCClientのステータスを更新
         */
        updateRtcStats: function () {
            const rtcStats = this.client.getRTCStats()
            const format = `[doctor] AgoraRTCStats | ${JSON.stringify(rtcStats)}`
            this.queueCwLogs(format)
            // console.log(format)
        },

        /**
         * ビデオの切り替え
         * @see https://docs.agora.io/en/Video/test_switch_device_web_ng?platform=Web
         */
        switchVideo: async function () {
            if (this.selectedVideoId === null || this.inProgress.switchLocalVideo) return
            this.inProgress.switchLocalVideo = true

            if (this.localVideo === null) {
                await this.initLocalVideo()
            }
            else {
                const currentLabel = this.localVideo.getTrackLabel()
                const selectedVideo = this.videos.find((video) => {
                    return video.deviceId === this.selectedVideoId
                })

                // 現在のビデオデバイスと異なるものが選択された場合のみ切り替え
                if (selectedVideo && selectedVideo.label !== currentLabel) {
                    this.localVideo.setDevice(this.selectedVideoId)
                        .then(() => {
                            this.queueCwLogs(`[doctor] switch local video success. label:${selectedVideo.label} deviceId:${selectedVideo.deviceId} groupId:${selectedVideo.groupId}`)
                        })
                        .catch((e) => {
                            this.queueCwLogs(`[doctor] switch local video failed. ${e}`)
                        })
                }
            }

            this.inProgress.switchLocalVideo = false
        },

        /**
         * オーディオの切り替え
         * @see https://docs.agora.io/en/Video/test_switch_device_web_ng?platform=Web
         */
        switchAudio: async function () {
            if (this.selectedAudioId === null || this.inProgress.switchLocalAudio) return
            this.inProgress.switchLocalAudio = true

            if (this.localAudio === null) {
                await this.initLocalAudio()
            }
            else {
                const currentLabel = this.localAudio.getTrackLabel()
                const selectedAudio = this.audios.find((audio) => {
                    return audio.deviceId === this.selectedAudioId
                })

                // 現在のオーディオデバイスと異なるものが選択された場合のみ切り替え
                if (selectedAudio && selectedAudio.label !== currentLabel) {
                    this.localAudio.setDevice(this.selectedAudioId)
                        .then(() => {
                            this.queueCwLogs(`[doctor] switch local audio success. label:${selectedAudio.label} deviceId:${selectedAudio.deviceId} groupId:${selectedAudio.groupId}`)
                        })
                        .catch((e) => {
                            this.queueCwLogs(`[doctor] switch local audio failed. ${e}`)
                        })
                }
            }

            this.inProgress.switchLocalAudio = false
        },

        /**
         * 医師のデバイスを監視
         * デバイスの追加・解除が発生した場合は接続状態更新する
         *
         * @see https://developer.mozilla.org/ja/docs/Web/API/MediaDevices/enumerateDevices
         */
        updateLocalDevices: function () {
            AgoraRTC.getCameras().then((devices) => {
                this.updateLocalVideos(devices)
            })
            AgoraRTC.getMicrophones().then((devices) => {
                this.updateLocalAudios(devices)
            })
        },

        /**
         * 医師のカメラ接続状態を更新
         *
         * @param {object} videos
         */
        updateLocalVideos: function (videos) {
            const prev = this.videos.map(video => video.deviceId)
            const current = videos.map(video => video.deviceId)
            this.videos = videos

            if (prev.length !== current.length) {
                // カメラ未接続
                if (current.length < 1) {
                    this.selectedVideoId = null
                    this.localVideoState = false
                    this.queueCwLogs('[doctor] updateLocalVideos: all local videos disconnected.')
                }
                // カメラ未接続状態からカメラを接続
                else if (prev.length < 1) {
                    this.selectedVideoId = this.autoSelectDevice(this.videos)
                    this.queueCwLogs('[doctor] updateLocalVideos: new local video connected.')
                }
                // 複数台カメラが接続された状態でカメラを追加
                else if (current.length > prev.length) {
                    this.queueCwLogs('[doctor] updateLocalVideos: additional new local video connected.')
                }
                // 複数台カメラが接続された状態でカメラを解除
                else if (prev.length > current.length) {
                    const currentVideo = this.videos.find(video => {
                        return video.deviceId === this.selectedVideoId
                    })
                    if (!currentVideo) {
                        this.selectedVideoId = this.autoSelectDevice(this.videos)
                    }
                    this.queueCwLogs('[doctor] updateLocalVideos: part of local video disconnected.')
                }

                this.logLocalTracks()
            }
            this.localVideoState = !!this.selectedVideoId
        },

        /**
         * 医師のマイク接続状態を更新
         *
         * @param {object} audios
         */
        updateLocalAudios: function (audios) {
            const prev = this.audios.map(audio => audio.deviceId)
            const current = audios.map(audio => audio.deviceId)
            this.audios = audios

            if (prev.length !== current.length) {
                // マイク未接続
                if (current.length < 1) {
                    this.selectedAudioId = null
                    this.queueCwLogs('[doctor] updateLocalAudios: all local audios disconnected.')
                }
                // マイク未接続状態からマイクを接続
                else if (prev.length < 1) {
                    this.selectedAudioId = this.autoSelectDevice(this.audios)
                    this.queueCwLogs('[doctor] updateLocalAudios: new local audio connected.')
                }
                // 複数台マイクが接続された状態でマイクを追加
                else if (current.length > prev.length) {
                    this.queueCwLogs('[doctor] updateLocalAudios: additional new local audio connected.')
                }
                // 複数台マイクが接続された状態でマイクを解除
                else if (prev.length > current.length) {
                    const currentAudio = this.audios.find(audio => {
                        return audio.deviceId === this.selectedAudioId
                    })
                    if (!currentAudio) {
                        this.selectedAudioId = this.autoSelectDevice(this.audios)
                    }
                    this.queueCwLogs('[doctor] updateLocalAudios: part of local audio disconnected.')
                }

                this.logLocalTracks()
            }
            this.localAudioState = !!this.selectedAudioId
        },

        /**
         * カメラ／マイクの自動切替
         *
         * @param {array} devices
         */
        autoSelectDevice: function (devices) {
            if (devices.length < 1) return null

            // システムデフォルトのデバイスを優先選択する（見つからない場合は先頭のデバイスを選択）
            const device = devices.find((device) => {
                return device.deviceId === 'default'
                    || device.label.includes('Built-in')
                    || device.label.includes('規定')
                    || device.label.includes('内蔵')
            }) || devices[0]

            if (device) {
                this.queueCwLogs(`[doctor] autoSelectDevice label:${device.label} kind:${device.kind} deviceId:${device.deviceId} groupId:${device.groupId}`)
            }
            return device ? device.deviceId : null
        },

        /**
         * ローカルデバイスの状態をログ収集
         */
        logLocalTracks: function () {
            if (!this.client || !this.client.localTracks) {
                return
            }
            this.client.localTracks.forEach((track, index) => {
                this.queueCwLogs(`[doctor] localTrackInfo[${index}] label:${track.getTrackLabel()} type:${track.trackMediaType} trackId:${track.getTrackId()} enabled:${track.enabled} isPlaying:${track.isPlaying}`)
            })
        },

        /**
         * フルスクリーン用のトグルイベント
         */
        fullscreenToggle: function () {
            this.$refs['fullscreen'].toggle()
        },

        /**
         * 画像撮影
         */
        capture: async function () {
            if (this.inProgress.capture) return
            this.inProgress.capture = true

            const video = document.getElementById('remote-video').getElementsByTagName('video')[0]
            const canvas = document.getElementById('canvas')
            const context = canvas.getContext('2d')

            canvas.width = video.clientWidth * 3
            canvas.height = video.clientHeight * 3
            context.drawImage(video, 0, 0, canvas.width, canvas.height)

            const formData = new FormData()
            formData.append('capture', canvas.toDataURL('image/png'))

            let endpoint = constants.doctor.consultations.endpoint.base
            endpoint += `/${this.consultation.id}/image`

            await axios.post(endpoint, formData)
                .then(({data}) => {
                    if (data.hasOwnProperty('url') && data.url) {
                        bus.$emit('alert-success', '画像を撮影しました。')
                    }
                    else {
                        bus.$emit('alert-danger', '画像の撮影に失敗しました。')
                    }
                })
                .catch(() => {
                    bus.$emit('alert-danger', '画像の撮影に失敗しました。')
                })

            this.inProgress.capture = false
        },

        /**
         * 画面サイズの切り替え
         */
        toggleLargeScreen: function () {
            this.videoSettings.isLargeScreen = !this.videoSettings.isLargeScreen
        },

        /**
         * マイクミュートの切り替え
         */
        toggleMuteAudio: function () {
            this.videoSettings.isMuteAudio = !this.videoSettings.isMuteAudio
            this.localAudio.setMuted(this.videoSettings.isMuteAudio)
            this.setIsMuteAudio(this.videoSettings.isMuteAudio)
            const format = `[doctor] toggle mute audio success. | ${this.videoSettings.isMuteAudio}`
            this.queueCwLogs(format)
            console.log(format)
        },

        /**
         * カメラミュートの切り替え
         */
        toggleMuteVideo: function () {
            this.videoSettings.isMuteVideo = !this.videoSettings.isMuteVideo
            this.localVideo.setMuted(this.videoSettings.isMuteVideo)
            // this.setIsMuteVideo(this.videoSettings.isMuteVideo)

            this.videoSettings.isMuteVideo ? this.localVideo.stop() : this.localVideo.play('local-video')

            const format = `[doctor] toggle mute video success. | ${this.videoSettings.isMuteVideo}`
            this.queueCwLogs(format)
            console.log(format)
        },

        /**
         * 背景ぼかしの切り替え
         */
        toggleBlur: async function () {
            if (this.localVideo === null) return

            this.videoSettings.isBlur = !this.videoSettings.isBlur
            this.setIsBlur(this.videoSettings.isBlur)

            try {
                if (this.videoSettings.isBlur) {
                    await this.enableVideoBlur()
                }
                else {
                    await this.disableVideoBlur()
                }
                const format = `[doctor] toggle virtual background processor success. | ${this.videoSettings.isBlur}`
                this.queueCwLogs(format)
                console.log(format)
            }
            catch (e) {
                const format = `[doctor] toggle virtual background processor failed. ${e}`
                this.queueCwLogs(format)
                console.log(format)
            }
        },

        /**
         * 背景ぼかしの有効化
         * @returns {Promise<void>}
         */
        enableVideoBlur: async function () {
            this.localVideo.pipe(this.processor.vb).pipe(this.localVideo.processorDestination)
            this.processor.vb.setOptions({ type: 'blur', blurDegree: 2 })
            await this.processor.vb.enable()
        },

        /**
         * 背景ぼかしの無効化
         * @returns {Promise<void>}
         */
        disableVideoBlur: async function () {
            await this.processor.vb.disable()
        },

        /**
         * ノイズリダクションの切り替え
         */
        toggleDenoiser: async function (isToggled = false) {
            if (this.localAudio === null) return

            if (!isToggled) {
                this.videoSettings.isDenoiser = !this.videoSettings.isDenoiser
            }
            this.setIsDenoiser(this.videoSettings.isDenoiser)

            try {
                if (this.videoSettings.isDenoiser) {
                    await this.enableDenoiser()
                }
                else {
                    await this.disableDenoiser()
                }
                const format = `[doctor] toggle denoiser processor success. | ${this.videoSettings.isDenoiser}`
                this.queueCwLogs(format)
                console.log(format)
            }
            catch (e) {
                const format = `[doctor] toggle denoiser processor failed. ${e}`
                this.queueCwLogs(format)
                console.log(format)
            }
        },

        /**
         * ノイズリダクションの有効化
         * @returns {Promise<void>}
         */
        enableDenoiser: async function () {
            this.localAudio.pipe(this.processor.denoiser).pipe(this.localAudio.processorDestination)
            await this.processor.denoiser.enable()
        },

        /**
         * ノイズリダクションの無効化
         * @returns {Promise<void>}
         */
        disableDenoiser: async function () {
            await this.processor.denoiser.disable()
        },

        /**
         * 画面共有の切り替え
         */
        toggleShareScreen: async function () {
            if (this.localScreen === null) {
                await this.initScreenClient()
                this.subscribeScreenEvents()

                await AgoraRTC.createScreenVideoTrack({})
                    .then((track) => {
                        this.localScreen = track
                        this.screenClient.publish(this.localScreen)

                        // YOKUMIRUの画面共有OFFボタンではなくブラウザ側の画面共有停止を経由したとき用
                        this.localScreen.addListener('track-ended', () => this.screenClient.unpublish(this.localScreen))
                        const format = `[doctor] create screen video track success. track:${this.uidScreen}`
                        this.queueCwLogs(format)
                        console.log(format)
                    })
                    .catch((e) => {
                        if (this.screenClient) {
                            this.screenClient.leave()
                        }
                        this.localScreen = null
                        this.screenClient = null
                        this.videoSettings.isShareScreen = false
                        const format = `[doctor] create screen video track failed. ${e}`
                        this.queueCwLogs(format)
                        console.log(format)
                    })
            }
            else {
                // ブラウザの画面共有状態を解除するために ILocalVideoTrack を close() する必要がある
                // IAgoraRTCClient の unpublish() だけではブラウザの画面共有状態は解除されない
                // @see https://api-ref.agora.io/en/video-sdk/web/4.x/interfaces/ilocalvideotrack.html#close
                this.localScreen.close()
                await this.screenClient.unpublish(this.localScreen)
                const format = `[doctor] close screen video track success. track:${this.uidScreen}`
                console.log(format)
            }
        },

        /**
         * 画面共有用クライアントの初期化
         *
         * @returns {Promise<void>}
         */
        initScreenClient: async function () {
            if (this.screenClient !== null) return

            this.screenClient = AgoraRTC.createClient({ mode: this.transcode, codec: 'vp8' })

            /**
             * @reference https://api-ref.agora.io/en/video-sdk/web/4.x/interfaces/iagorartcclient.html#event_user_joined
             */
            await this.screenClient.join(this.apiKey, this.roomKey, this.screenToken, this.uidScreen)
                .then((uid) => {
                    this.queueCwLogs(`[doctor] screen client join success. uid:${uid}`)
                })
                .catch((e) => {
                    this.agoraInitState.errorHandled = true
                    this.queueCwLogs(`[doctor] screen client join failed. ${e}`)
                })
        },

        /**
         * 画面共有クライアントのAgoraイベントリスナ追加
         */
        subscribeScreenEvents: function () {
            /**
             * @reference https://api-ref.agora.io/en/video-sdk/web/4.x/interfaces/iagorartcclient.html#event_user_joined
             */
            this.screenClient.on('user-joined', async (remoteUser) => {
                // 自身の画面共有ではない場合
                if (this.initialStrNum(remoteUser.uid) !== '5') {
                    return
                }
                this.queueCwLogs('[doctor] local screen user joined.')
            })

            /**
             * @reference https://api-ref.agora.io/en/video-sdk/web/4.x/interfaces/iagorartcclient.html#event_user_published
             */
            this.client.on('user-published', async (remoteUser, mediaType) => {
                // 自身の画面共有ではない場合
                if (this.initialStrNum(remoteUser.uid) !== '5') {
                    return
                }
                this.videoSettings.isShareScreen = true
                this.queueCwLogs('[doctor] local screen published.')
            })

            this.client.on('user-unpublished', async (remoteUser, mediaType) => {
                // 自身の画面共有ではない場合
                if (this.initialStrNum(remoteUser.uid) !== '5') {
                    return
                }

                if (this.screenClient) {
                    this.screenClient.leave()
                }

                this.localScreen = null
                this.screenClient = null
                this.videoSettings.isShareScreen = false
                this.queueCwLogs('[doctor] local screen unpublished.')
            })
        },
    },
}
</script>

<style lang="scss">
.settingIconsWrapper {
    margin-top: 8px;

    .settingIcon {
        position: relative;
        z-index: 2;
        width: 36px;
        height:36px;
        margin: 0 5px;
        cursor: pointer;
        background: #fff;
        border: 2px solid #5C5D5E;
        border-radius: 50%;

        &:hover::before {
            position: absolute;
            left: -36px;
            bottom: -23px;
            content: '';
            display: block;
            width: 100px;
            color: #fff;
            font-size: 12px;
            text-align: center;
            background: #5C5D5E;
            border-radius: 4px;
        }

        &.iconLargeScreenOff {
            &:hover::before {
                content: '画面拡大: OFF';
            }
        }
        &.iconLargeScreenOn {
            background: #F77696;
            border: 2px solid #F77696;

            &:hover::before {
                content: '画面拡大: ON';
                background: #F77696;
            }
        }

        &.iconMuteAudioOff {
            &:hover::before {
                content: 'マイクミュート: OFF';
            }

            svg {
                fill: #5C5D5E;
            }
        }
        &.iconMuteAudioOn {
            background: #F77696;
            border: 2px solid #F77696;

            &:hover::before {
                content: 'マイクミュート: ON';
                background: #F77696;
            }

            svg {
                fill: #fff;
            }
        }

        &.iconMuteVideoOff {
            &:hover::before {
                content: 'ビデオミュート: OFF';
                left: -52px;
                width: 130px;
            }

            svg {
                fill: #5C5D5E;
            }
        }
        &.iconMuteVideoOn {
            background: #F77696;
            border: 2px solid #F77696;

            &:hover::before {
                content: 'ビデオミュート: ON';
                background: #F77696;
                left: -52px;
                width: 130px;
            }

            svg {
                fill: #fff;
            }
        }

        &.iconBlurOff {
            &:hover::before {
                content: '背景ぼかし: OFF';
            }
        }
        &.iconBlurOn {
            background: #F77696;
            border: 2px solid #F77696;

            &:hover::before {
                content: '背景ぼかし: ON';
                background: #F77696;
            }
        }

        &.iconShareScreenOff {
            &:hover::before {
                content: '画面共有: OFF';
            }

            svg {
                fill: #5C5D5E;
            }
        }
        &.iconShareScreenOn {
            background: #F77696;
            border: 2px solid #F77696;

            &:hover::before {
                content: '画面共有: ON';
                background: #F77696;
            }

            svg {
                fill: #fff;
            }
        }

        img {
            width: 60%;
        }
    }
}

.videoContainer {
    position: relative;
    width: 100%;

    &::before {
        content: '';
        display: block;
        padding-top: 75%;
    }

    .videoContainer__inner {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }

    .videoContainer__dummy {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: #f1f1f1;
        text-align: center;

        .videoContainerDummyImage {
            height: 90% !important;
        }
    }

    .localVideoWrapper {
        position: relative;
        width: 100%;
        height: 100%;

        #local-video {
            display: block;
            width: 100%;
            height: 100%;
        }

        .localVideoMuted {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: #f8f8f8;

            svg {
                fill: #5C5D5E;
                font-size: 60px;
            }
        }
    }

    .remoteVideoWrapper {
        position: relative;
        width: 100%;
        height: 100%;

        #remote-video {
            display: block;
            width: 100%;
            height: 100%;
        }

        .remoteVideoMuted {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: #f8f8f8;

            svg {
                fill: #5C5D5E;
                font-size: 60px;
            }
        }
    }

    .localVideoLogo {
        position: absolute;
        right: 10px;
        top: 7px;
        width: 120px;

        &.large {
            right: 15px;
            top: 10px;
            width: 180px;
        }
    }

    &.videoContainer--fluid {
        height: auto;

        &::before {
            content: '';
            display: none;
            padding-top: 0;
        }

        .videoContainer__inner {
            position: static;
            width: 100%;
            height: auto;
        }

        #local-video {
            > div {
                width: 100% !important;
                height: auto !important;
                background: transparent !important;
            }

            video {
                position: static !important;
                width: 100% !important;
                height: auto !important;
            }
        }

        #remote-video {
            > div {
                width: 100% !important;
                height: auto !important;
                background: transparent !important;
            }

            video {
                position: static !important;
                width: 100% !important;
                height: auto !important;
            }
        }
    }

    .c-icon--fullscreen {
        position: absolute;
        right: 0;
        bottom: 6px;
        width: 28px;
        height: 28px;
        cursor: pointer;
    }

    .video-capture {
        position: absolute;
        left: 0;
        bottom: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 28px;
        padding: 0 6px;
        color: #fff;
        font-size: .75rem;
        background: #244787;
        cursor: pointer;

        &.video-capture--consul {
            background: #DA5772;
        }

        &.video-capture--progress {
            opacity: .5;
            pointer-events: none;
        }
    }

    .c-icon--camera {
        width: 18px;
        height: 18px;
        margin-right: 4px;
        background-color: transparent;
        background-size: cover;

        + div {
            line-height: 28px;
        }
    }

    span {
        margin: auto;
    }
}

.devicesWrapper {
    margin-top: 10px;

    .deviceContainer {
        position: relative;

        div {
            width: 100%;
        }

        svg {
            position: absolute;
            left: 10px;
            top: 12px;
            fill: #5c5d5e;
        }

        select {
            cursor: pointer;
            padding-left: 32px;
        }
    }
}

.deviceStateWrapper {
    .deviceStateIcon {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        margin: 0 4px;
        background: #fff;
        border-radius: 5px;

        &::before {
            content: '';
            display: none;
            position: absolute;
            left: 0;
            top: -27px;
            z-index: 2;
            height: 24px;
            padding-left: 8px;
            line-height: 24px;
            color: #fff;
            font-size: .75rem;
            letter-spacing: 0;
            box-sizing: border-box;
            border-radius: 4px;
        }

        &.deviceStateIconAudio {
            svg {
                fill: #dc3545;
            }

            &:hover {
                &::before {
                    content: 'マイクが認識できません';
                    display: block;
                    left: calc(-75px + 50%);
                    width: 150px;
                    background: #dc3545;
                }
            }
        }

        &.deviceStateIconVideo {
            svg {
                fill: #dc3545;
            }

            &:hover {
                &::before {
                    content: 'カメラが認識できません';
                    display: block;
                    left: calc(-75px + 50%);
                    width: 150px;
                    background: #dc3545;
                }
            }
        }
    }

    &.deviceStateWrapperActiveAudio {
        .deviceStateIcon {
            &.deviceStateIconAudio {
                svg {
                    fill: #2fa69a;
                }

                &:hover {
                    &::before {
                        content: 'マイクが認識されています';
                        display: block;
                        left: calc(-81px + 50%);
                        width: 162px;
                        background: #2fa69a;
                    }
                }
            }
        }
    }

    &.deviceStateWrapperActiveVideo {
        .deviceStateIcon {
            &.deviceStateIconVideo {
                svg {
                    fill: #2fa69a;
                }

                &:hover {
                    &::before {
                        content: 'カメラが認識されています';
                        display: block;
                        left: calc(-81px + 50%);
                        width: 162px;
                        background: #2fa69a;
                    }
                }
            }
        }
    }

    &.deviceStateWrapperMuteAudio {
        .deviceStateIcon {
            &.deviceStateIconAudio {
                svg {
                    fill: #5C5D5E;
                }

                &:hover {
                    &::before {
                        content: 'マイクはミュート中です';
                        display: block;
                        left: calc(-75px + 50%);
                        width: 150px;
                        background: #5C5D5E;
                    }
                }
            }
        }
    }

    &.deviceStateWrapperMuteVideo {
        .deviceStateIcon {
            &.deviceStateIconVideo {
                svg {
                    fill: #5C5D5E;
                }

                &:hover {
                    &::before {
                        content: 'カメラはミュート中です';
                        display: block;
                        left: calc(-75px + 50%);
                        width: 150px;
                        background: #5C5D5E;
                    }
                }
            }
        }
    }
}

.toggleDenoiserWrapper {
    margin-top: 5px;

    > div {
        margin-right: 5px;
        font-size: 14px;
    }
}

.audioVolumeAnimationWrapper {
    width: 24px;
    height: 24px;

    > div {
        width: 5px;
        height: 5px;
        margin: 0 1px;
        border-radius: 50%;
        background: #fff;
    }
}

.alertLowNetwork {
    .btn-close {
        position: relative;
        width: 20px;
        height: 20px;
        min-width: 20px;
        color: #fff;
        line-height: 20px;
        font-weight: bold;
        text-align: center;
        border-radius: 50%;
        cursor: pointer;
        background: #856404;
    }
}
</style>
